import { create } from 'zustand';
import { fetchRotationsList } from '@libs/api/shifts';
import { RecurrenceListItem, SHIFT_STATUSES } from '@libs/models/shifts/shift';
import { FiltersCollection } from '../../filters';
import { DEFAULT_PAGE_SIZE } from '@molecules/dataDisplay';

type State = {
  loading: boolean;
  initiated: boolean;
  data: RecurrenceListItem[];
  page: number;
  total: number;
  perPage: number;
  loadSeriesNRotations: (page: number, perPage: number, filters: FiltersCollection) => Promise<void>;
  showDetails: boolean;
  currentShift: RecurrenceListItem | null;
  openShiftDetails: (id: string) => void;
  closeShiftDetails: () => void;
};

export const useRotationsListStore = create<State>()((set, get) => ({
  loading: false,
  initiated: false,
  data: [],
  page: 1,
  perPage: DEFAULT_PAGE_SIZE,
  total: 0,
  loadSeriesNRotations: async (page, perPage, filters) => {
    set({ loading: true });
    const applyFilters = filters ? { ...filters } : {};
    // add filter for Deleted status, if it's not already there
    if (!applyFilters.statuses) {
      applyFilters.statuses = {
        key: 'status',
        value: [
          SHIFT_STATUSES.ASSIGNED,
          SHIFT_STATUSES.CANCELED,
          SHIFT_STATUSES.COMPLETED,
          // SHIFT_STATUSES.DELETED,
          SHIFT_STATUSES.EXPIRED,
          SHIFT_STATUSES.IN_PROGRESS,
          SHIFT_STATUSES.OPENED,
          SHIFT_STATUSES.PENDING,
          SHIFT_STATUSES.REASSIGNED,
          SHIFT_STATUSES.UNASSIGNED,
          SHIFT_STATUSES.UNFILLED,
        ],
      };
    }
    try {
      const resp = await fetchRotationsList(page, perPage, applyFilters);
      set({
        loading: false,
        data: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loading: false, initiated: true });
    }
  },
  currentShift: null,
  showDetails: false,
  openShiftDetails: (id) => {
    const { data } = get();
    const shift = data.find((s) => s.id === id);
    set({ currentShift: shift, showDetails: true });
  },
  closeShiftDetails: () => {
    set({ showDetails: false });
  },
}));
